import { QUERY_RETRY_COUNT } from "utils/constants/api.constants";

const handleRetryFailure = (fn: () => void) => {
  return (count: number) => {
    if (count < QUERY_RETRY_COUNT) {
      return true;
    } else {
      fn();

      return false;
    }
  };
};

export default handleRetryFailure;
